import { createAction } from "@reduxjs/toolkit";
import {
  getAllPostsBySubscriptionActionTypes,
  getMorePostsBySubscriptionActionTypes,
  getPostsBySubscriptionActionTypes,
  getSibilingPostsInSubscroptionActionTypes,
  setPostsBySubscriptionActionType,
} from "./actionTypes";

export const getAllPostsBySubscription = createAction(
  getAllPostsBySubscriptionActionTypes.request,
);
export const getAllPostsBySubscriptionSuccess = createAction(
  getAllPostsBySubscriptionActionTypes.success,
);
export const getAllPostsBySubscriptionFailure = createAction(
  getAllPostsBySubscriptionActionTypes.failure,
);
export const getAllPostsBySubscriptionReset = createAction(
  getAllPostsBySubscriptionActionTypes.reset,
);

export const getPostsBySubscription = createAction(
  getPostsBySubscriptionActionTypes.request,
);
export const getPostsBySubscriptionSuccess = createAction(
  getPostsBySubscriptionActionTypes.success,
);
export const getPostsBySubscriptionFailure = createAction(
  getPostsBySubscriptionActionTypes.failure,
);
export const getPostsBySubscriptionReset = createAction(
  getPostsBySubscriptionActionTypes.reset,
);

export const getMorePostsBySubscription = createAction(
  getMorePostsBySubscriptionActionTypes.request,
);
export const getMorePostsBySubscriptionSuccess = createAction(
  getMorePostsBySubscriptionActionTypes.success,
);
export const getMorePostsBySubscriptionFailure = createAction(
  getMorePostsBySubscriptionActionTypes.failure,
);

export const getSibilingPosts = createAction(
  getSibilingPostsInSubscroptionActionTypes.request,
);
export const getSibilingPostsSuccess = createAction(
  getSibilingPostsInSubscroptionActionTypes.success,
);
export const getSibilingPostsFailure = createAction(
  getSibilingPostsInSubscroptionActionTypes.failure,
);

export const setPostsBySubscription = createAction(
  setPostsBySubscriptionActionType,
);
